export const locationPagesURLs: Record<string, number> = {
    "/allentown-pa-meal-delivery": 649533,
    "/atlanta-ga-delivery": 650225,
    "/augusta-me-meal-delivery": 650153,
    "/baltimore-md-meal-delivery": 649735,
    "/boston-ma-meal-delivery": 650176,
    "/charlotte-nc-delivery": 650213,
    "/chicago-il-meal-delivery": 649631,
    "/cincinnati-oh-meal-delivery": 649617,
    "/cleveland-oh-meal-delivery": 649603,
    "/columbia-sc-delivery": 650219,
    "/columbus-oh-meal-delivery": 649608,
    "/concord-nh-meal-delivery": 650160,
    "/des-moines-ia-meal-delivery": 650125,
    "/detroit-mi-meal-delivery": 650146,
    "/durham-nc-meal-delivery": 649588,
    "/greensboro-nc-meal-delivery": 649582,
    "/hartford-ct-meal-delivery": 650188,
    "/indianapolis-in-meal-delivery": 649643,
    "/jersey-city-nj-meal-delivery": 649502,
    "/lancaster-pa-meal-delivery": 649708,
    "/lansing-mi-meal-delivery": 650136,
    "/lexington-ky-meal-delivery": 649694,
    "/louisville-ky-meal-delivery": 649688,
    "/madison-wi-meal-delivery": 650109,
    "/memphis-tn-delivery": 650201,
    "/milwaukee-wi-meal-delivery": 650119,
    "/minneapolis-mn-delivery": 650237,
    "/montgomery-al-delivery": 650231,
    "/montpelier-vt-meal-delivery": 650167,
    "/nashville-tn-delivery": 650207,
    "/new-york-ny-meal-delivery": 649496,
    "/norfolk-va-meal-delivery": 649568,
    "/peoria-in-meal-delivery": 649660,
    "/philadelphia-pa-meal-delivery": 649544,
    "/princeton-nj-meal-delivery": 649512,
    "/providence-ri-meal-delivery": 650182,
    "/raleigh-nc-meal-delivery": 649594,
    "/richmond-va-meal-delivery": 649562,
    "/springfield-il-meal-delivery": 649676,
    "/st-louis-mo-meal-delivery": 649682,
    "/stpaul-mn-meal-delivery": 650103,
    "/tallahassee-fl-delivery": 650103,
    "/virginia-beach-va-meal-delivery": 649574,
    "/washington-dc-meal-delivery": 649329,
    "/wilmington-de-meal-delivery": 649556,
};